import { prop } from 'ramda'
import React from 'react'

import { useMultiSelectState } from './MultiSelectHandler'
import Loading from '../helpers/Loading'
import Marker from '../shapes/Marker'

const SelectAllCheckbox = ({ data, onSelectAll, rowKey = 'id' }) => {
  const [loading, setLoading] = React.useState(false)
  const { active, isAllSelected, selecteds, handleSelect, selectAll, mergeSelecteds } = useMultiSelectState() || {}

  if (!active || (!onSelectAll && !data)) return false

  onSelectAll = onSelectAll || (() => data)

  const handleSelectAll = () => {
    setLoading(true)
    Promise.resolve(onSelectAll())
      .then(records => {
        mergeSelecteds(records.map(prop(rowKey)))
      })
      .finally(() => {
        setLoading(false)
      })
  }

  if (loading) return <Loading />

  return <Marker size="small" value={data && isAllSelected(data)} onChange={handleSelectAll} />
}

export default SelectAllCheckbox
